/* eslint-disable */
// These definitions need to be maintained for compatibility with certain node.js scripts
// In the unlikely event of any changes, remember to keep in sync with @ratehub/documents/common
module.exports = {
    ENGLISH: "en-CA",
    FRENCH: "fr-CA",
    PSEUDO: "en-xa",
}
